<template>

<div id="sub-banner-image-container">
  <img src="../assets/banner.jpg" alt="Islamic Dynasties">
  <div id="sub-banner-overlay">
    <div id="sub-banner-overlay-text">{{ this.$i18n.t("IslDyn_header") }}</div>
  </div>
</div>

</template>



<script>

import { loadLocaleMessages } from "../i18n.js";
import media from "../mixins/media.js";
export default { 
  name: "SubBanner",
  props: ["siteLanguage"],
  mixins: [media],
  data() {
    return {
      lessThan724: window.matchMedia("(max-width: 724px)").matches,
      imageURL: "",
      objectURL: "",
      objectInfo: {},
      objectInfoLoaded: false
    }
  },
  watch: {
    "siteLanguage" () {
      loadLocaleMessages(this.siteLanguage);
    }
  },
  mounted () {
    loadLocaleMessages(this.siteLanguage);
  }
}

</script>



<style scoped lang="scss">

#sub-banner-image-container {
  position: relative;
  height: 20vh;
  min-height: 50px;
  max-height: 150px;
  width: 100%;
}
  #sub-banner-image-container img {
    @include image-scale;
    object-fit: cover;
  }
  #sub-banner-overlay {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    min-height: 50px;
    width: 100%;
  }
    #sub-banner-overlay-text {
      font-size: 190%;
      color: #ffeeab;
      padding: 10px 10px 10px 50px;
    }
    #sub-banner-copyright {
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: inherit;
      color: rgba(255, 255, 255, 0.8);
      font-size: 90%;
      font-style: italic;
      padding-right: 50px;
    }
      #sub-banner-copyright-name {
        font-weight: bold;
      }

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #sub-banner-image-container {
    background-size: cover;
  }
  #sub-banner-image-container img {
    display: none;
  }
}

@media only screen and (max-width: 1199px) {
  #sub-banner-overlay-text {
    font-size: 170%;
  }
}

@media only screen and (max-width: 849px) {
  #sub-banner-overlay-text {
    font-size: 155%;
  }
}

@media only screen and (max-width: 724px) {
  #sub-banner-image-container {
    max-height: 100px;
  }
   #sub-banner-overlay {
    min-height: 40px;
  }
    #sub-banner-overlay-text {
      font-size: 145%;
      padding: 5px 5px 5px 50px;
    }
}

@media only screen and (max-width: 599px) {
  #sub-banner-image-container {
    max-height: 80px;
  }
   #sub-banner-overlay {
    min-height: 35px;
  }
    #sub-banner-overlay-text {
      font-size: 130%;
      padding: 5px 5px 5px 30px;
    }
}

@media print {
  #sub-banner-image-container {
    display: none;
  }
}

</style>